/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/alt-text */
import React, { Component, Fragment } from "react";
import { Form, Input, Table, Modal, Radio, Spin, DatePicker } from "antd";
// import { GetMaSkill, AddMaSkill } from "../../../actions/taskAction";
// import { connect } from "react-redux";
import moment from "moment";
import Api from "../../../services/ServiceApi";
import Cookies from "js-cookie";
// import { Link } from "react-router-dom";

class JobSkill extends Component {
  formRef = React.createRef();
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      active: 0,
      menu: [
        { icon: "ma_list.svg", title: "MA List", link: "" },
        {
          icon: "ma_team_service.svg",
          title: "MA Team Service",
          link: "/ma_team_service",
        },
        { icon: "", title: "Material Stock", link: "/material_stock" },
        {
          icon: "notifications.svg",
          title: "Notifications",
          link: "/notifications",
        },
        { icon: "report.svg", title: "Report", link: "/report" },
        { icon: "", title: "Setting", link: "/setting" },
      ],
      visible: false,
      visible_approve: false, // for opening and closing of approve modal
      visible_reject: false,
      visible_delete: false,
      loading_modal_delete: false,
      value: 1,
      title: "Job Skill",
      data: [],
      master_data: [],
      columns: [
        {
          title: "Job Skill ID",
          render: (item) => (!item.ma_skill_id ? "-" : item.ma_skill_id),
          align: "center",
          key: "ma_skill_id",
          sorter: (a, b) =>
          (a.ma_skill_id === null || a.ma_skill_id  === undefined ? 0: a.ma_skill_id) -
          (b.ma_skill_id === null || b.ma_skill_id  === undefined ? 0: b.ma_skill_id),        
        },
        {
          title: "Job Skill Name",
          render: (item) => (!item.ma_skill_name ? "-" : item.ma_skill_name),
          align: "center",
          key: "ma_skill_name",
          sorter: (a, b) =>
          (a.ma_skill_name === null || a.ma_skill_name  === undefined ? "" : a.ma_skill_name).localeCompare
          (b.ma_skill_name === null || b.ma_skill_name  === undefined ? "" : b.ma_skill_name),          
        },
        {
          title: "Create by",
          render: (item) => (!item.create_by ? "-" : item.create_by),
          align: "center",
          key: "create_by",
          sorter: (a, b) =>
          (a.create_by === null || a.create_by  === undefined ? 0: a.create_by) -
          (b.create_by === null || b.create_by  === undefined ? 0: b.create_by),         
        },
        {
          title: "Effective date",
          align: "center",
          key: "effective_date",
          render: (item) =>
            !item.effective_date ? (
              "-"
            ) : (
              <div>{moment(item.effective_date).format("DD/MM/YYYY")}</div>
            ),
            sorter: (a, b) =>
            (a.effective_date === null || a.effective_date  === undefined ? "": a.effective_date).localeCompare
            (b.effective_date === null || b.effective_date  === undefined ? "": b.effective_date),  
        },
        {
          title: "Expire date",
          key: "expire_date",
          align: "center",
          render: (item) =>
            !item.expire_date ? (
              "-"
            ) : (
              <div>{moment(item.expire_date).format("DD/MM/YYYY")}</div>
            ),

            sorter: (a, b) =>
            (a.expire_date === null || a.expire_date  === undefined ? "": a.expire_date).localeCompare
            (b.expire_date === null || b.expire_date  === undefined ? "": b.expire_date),         
          },
        {
          title: "Status",
          // render: (item) => (!item.status? "-": item.status),
          key: "status",
          render: (item) => (
            <div>
              {item === 0 ? (
                <span></span>
              ) : (
                <span className="c-green">
                  <span className="dot-active mr-2"></span>Active
                </span>
              )}
            </div>
          ),
          sorter: () => null,
        },
        {
          title: "Action",
          render: (item) => (
            <div>
              <a onClick={() => this.onModal("edit", true, item)}>
                <img src={Api.absoluteUrl("/icon/edit.svg")} />
              </a>
              <a onClick={() => this.onModal("delete", true, item)}>
                <img src={Api.absoluteUrl("/icon/delete.svg")} />
              </a>
            </div>
          ),
          sorter: () => null,
        },
      ],
      processType: null,
      modal_item: {},
      dateFormatList: ["DD/MM/YYYY", "DD/MM/YY"],
    };
  }

  async componentDidMount() {
    document.title = this.state.title;
    this.LoadData();
  }

  LoadData = async () => {
    const asset = await Api.post("v2/get_ma_skill", {
      pk_id: null,
      is_active: 1,
      effective: null,
      sql_where: null,
      company_id: Cookies.get("companyid"),
      operator_id: Cookies.get("operator_id"),
    });
    console.log(asset);
    this.setState({
      data: asset.data.data,
      master_data: asset.data.data,
    });
  }

  async handleSubmit(values) {
    const { modal_item } = this.state;
    var form = {};
    console.log(values);
    if (this.state.processType == "add") {
      // form["update_by"] = Cookies.get("userId");
      // form["icon_name"] = "";
      form["company_id"] = Cookies.get("companyid");
      form["operator_id"] = Cookies.get("operator_id");
      form["project_id"] = Cookies.get("project_id");
      form["ma_skill_id"] = 0;
      form["ma_skill_name"] = values.ma_skill_name;
      form["is_active"] = 1;
      form["effective_date"] = moment(values.effective_date).format("YYYY-MM-DD HH:mm");
      form["expire_date"] = values.expire_date != undefined  ? moment(values.expire_date).format("YYYY-MM-DD HH:mm") : null;
      form["create_date"] = moment(new Date()).format("YYYY-MM-DD HH:mm");
      form["create_by"] = Cookies.get("username");
      form["form_id"] = "";
      form["data_dynamic"] = null;

      console.log(form);

      await Api.post("v2/Update_Ma_Skill", form).then((val) => {
        if (val.data.result.code !== "F") {
          this.OnViewApprove(this.renderApproveButtonModal());
          this.formRef.current.resetFields();
        } else {
          this.OnViewReject(this.renderRejectButtonModal());
        }
      });

      //reloadin data
      this.LoadData();

    } else if (this.state.processType == "edit") {
      // form["update_by"] = Cookies.get("userId");
      // form["icon_name"] = "";
      form["company_id"] = Cookies.get("companyid");
      form["operator_id"] = Cookies.get("operator_id");
      form["project_id"] = Cookies.get("project_id");
      form["ma_skill_id"] = modal_item.ma_skill_id;
      form["ma_skill_name"] = values.ma_skill_name;
      form["is_active"] = 1;
      form["effective_date"] = moment(values.effective_date).format("YYYY-MM-DD HH:mm");
      form["expire_date"] = values.expire_date != undefined  ? moment(values.expire_date).format("YYYY-MM-DD HH:mm") : null;
      form["create_date"] = moment(new Date()).format("YYYY-MM-DD HH:mm");
      form["create_by"] = Cookies.get("username");
      form["form_id"] = "";
      form["data_dynamic"] = null;

      await Api.post("v2/Update_Ma_Skill", form).then((val) => {
        if (val.data.result.code !== "F") {
          this.OnViewApprove(this.renderApproveButtonModal());
          this.formRef.current.resetFields();
        } else {
          this.OnViewReject(this.renderRejectButtonModal());
        }
      });

      //reloadin data
      this.LoadData();
      // await Api.post("v2/get_ma_skill", {
      //   pk_id: null,
      //   is_active: 1,
      //   effective: null,
      //   sql_where: null,
      //   company_id: Cookies.get("companyid"),
      //   operator_id: Cookies.get("operator_id"),
      // }).then((val) => {
      //   console.log(val);
      //   if (val.data.result.code === "P") {
      //     this.setState({
      //       data: val.data.data.result_ma_skill_list,
      //     });
      //   }
      // });
    }
  }

  async handleDelete() {
    const { modal_item } = this.state;
    var form = {};

      form["company_id"] = Cookies.get("companyid");
      form["operator_id"] = Cookies.get("operator_id");
      form["project_id"] = Cookies.get("project_id");
      form["ma_skill_id"] = modal_item.ma_skill_id;
      form["ma_skill_name"] = modal_item.ma_skill_name;
      form["is_active"] = 0;
      form["effective_date"] = moment(modal_item.effective_date).format("YYYY-MM-DD HH:mm");
      form["expire_date"] = modal_item.expire_date != undefined  ? moment(modal_item.expire_date).format("YYYY-MM-DD HH:mm") : null;
      form["create_date"] = moment(new Date()).format("YYYY-MM-DD HH:mm");
      form["create_by"] = Cookies.get("username");
      form["form_id"] = "";
      form["data_dynamic"] = null;

    console.log(form);

    await Api.post("v2/Update_Ma_Skill", form).then((val) => {
      if (val.data.result.code !== "F") {
        this.OnViewApprove(this.renderApproveButtonModal());
      } else {
        this.OnViewReject(this.renderRejectButtonModal());
      }
    });



    //reloadin data
    this.LoadData();
    // await Api.post("v2/get_ma_skill", {
    //   pk_id: null,
    //   is_active: 1,
    //   effective: null,
    //   sql_where: null,
    //   company_id: Cookies.get("companyid"),
    //   operator_id: Cookies.get("operator_id"),
    // }).then((val) => {
    //   console.log(val);
    //   if (val.data.result.code === "P") {
    //     this.setState({
    //       data: val.data.data.result_data,
    //     });
    //   }
    // });
  }

  onChange = (e) => {
    this.setState({ value: e.target.value });
  };

  async onModal(mode, visible, item) {
    if (mode === "add") {
      this.setState({
        mode: mode,
        processType: mode,
        visible: visible,
      });
    } else if (mode === "edit") {
      console.log(item);
      this.setState({
        mode: mode,
        processType: mode,
        visible: visible,
        modal_item: item,
      });
      {
        setTimeout(() => {
          this.formRef.current.setFieldsValue({
            ma_skill_name: item.ma_skill_name,
            effective_date:  moment(item.effective_date),
            expire_date:  item.expire_date ? moment(item.expire_date) : null,
            status: item.is_active,
          });
        }, 0);
      }
    } else if (mode === "delete") {
      this.setState({
        processType: mode,
        visible_delete: visible,
        modal_item: item,
      });
    }
  }

  returnSetFieldValueDate(item) {
    if (!item || item == undefined) {
      console.log("null");
      return null;
    } else {
      console.log(item);
      return moment(item);
    }
  }

  testAdd = (index, values) => {
    // var form = {
    //     create_by: 3,
    //     create_date: "2020-05-21T14:39:03",
    //     effective_date: "2010-01-01T00:00:00",
    //     expire_date: "2030-01-01T00:00:00",
    //     ma_skill_id: 1,
    //     ma_skill_name: "Skill #1",
    //     update_by: null,
    //     update_date: "2020-05-21T14:39:03"
    // }
    var form = {
      create_by: 3,
      create_date: "2020-05-21T14:39:03",
      effective_date: "2010-01-01T00:00:00",
      expire_date: "2030-01-01T00:00:00",
      ma_skill_id: 1,
      ma_skill_name: "Skill #3",
      update_by: null,
      update_date: "2020-05-21T14:39:03",
    };
    var data = [...this.state.data];
    //data.unshift(form)
    data[0] = form;
    this.setState({ data });
  };

  //Close the modal
  ModalClosed = () => {
    this.setState({
      visible: false,
      visible_delete: false,
    });
  };

  renderModal() {
    const { visible, title, mode, dateFormatList } = this.state;
    return (
      <Modal
        title={
          <span className="font-mont-b fs-16 c-blue text-uppercase">
            {mode} {title}
          </span>
        }
        closable={true}
        visible={visible}
        footer={false}
        onCancel={this.ModalClosed}
        destroyOnClose={true}
      >
        <div className="row justify-content-center">
          <div className="col-8">
            <Form
              onFinish={(mode, values) => this.handleSubmit(mode, values)}
              layout="vertical"
              ref={this.formRef}
            >
              <Form.Item
                name="status"
                label="Status"
                rules={[{ required: true, message: "Status is required" }]}
              >
                <Radio.Group>
                  <Radio value={1}>
                    <span className="font-thai-r fs-18">Active</span>
                  </Radio>
                  <Radio value={0}>
                    <span className="font-thai-r fs-18">Inactive</span>
                  </Radio>
                </Radio.Group>
              </Form.Item>
              <Form.Item
                name="ma_skill_name"
                label="Job Skill Name"
                rules={[
                  { required: true, message: "Job skill name is required" },
                ]}
              >
                <Input
                  className="inputfile"
                  type="text"
                  size="large"
                  placeholder="Please Input"
                />
              </Form.Item>
              <Form.Item
                name="effective_date"
                label="Effective Date"
                rules={[
                  {
                    required: true,
                    message: "Effective Date are required",
                  },
                ]}
              >
                <DatePicker
                  className="inputfile"
                  type="text"
                  size="large"
                  style={{ width: "100%" }}
                  name="size"
                  format={dateFormatList}
                ></DatePicker>
              </Form.Item>
              <Form.Item
                name="expire_date"
                label="Expire Date"
              >
                <DatePicker
                  className="inputfile"
                  type="text"
                  size="large"
                  style={{ width: "100%" }}
                  name="size"
                  format={dateFormatList}
                ></DatePicker>
              </Form.Item>
              <Form.Item className="mb-0 text-center">
                <button
                  type="reset"
                  onClick={() => this.setState({ visible: false })}
                  className="btn btn-secondary"
                >
                  Cancel
                </button>
                <button className="btn btn-success">{mode}</button>
              </Form.Item>
            </Form>
          </div>
        </div>
      </Modal>
    );
  }

  // Opening approve
  OnViewApprove() {
    this.setState({
      visible_approve: true,
    });
  }

  // Open Failed Modal
  OnViewReject() {
    this.setState({
      visible_reject: true,
    });
  }

  renderDelete() {
    const { loading_modal_delete, visible_delete } = this.state;
    // Add Material Form
    return (
      <Fragment>
        <Modal
          title={"Delete Job Category"}
          centered={true}
          visible={visible_delete}
          footer={false}
          destroyOnClose={true}
          onCancel={this.ModalClosed}
        >
          <Spin spinning={loading_modal_delete}>
            {/* <Form onFinish={this.handleAdd} ref={this.formEditRef} layout="vertical"> */}

            <div className="row">
              <div className="col text-center justify-content-between">
                {window.location.hostname == "localhost" ? (
                  <img src={Api.absoluteUrl("/icon/approve_check.svg")} />
                ) : (
                  <img src={Api.absoluteUrl("./icon/approve_check.svg")} />
                )}
              </div>
            </div>

            <div className="row" style={{ margin: "20px 10px 40px 10px" }}>
              <div className="col text-center justify-content-between">
                <span
                  style={{
                    fontFamily: "MontserratM",
                    fontWeight: "bold",
                    color: "#0500A3",
                  }}
                >
                  Are you sure?
                </span>
              </div>
            </div>

            <div
              style={{
                fontFamily: "MontserratM",
                fontWeight: "bold",
                color: "#0500A3",
              }}
            >
              <div>
                <div className="row">
                  <div className="col text-center justify-content-between">
                    <button
                      type="reset"
                      style={{ width: "120px" }}
                      onClick={() => this.setState({ visible_delete: false })}
                      className="btn btn-secondary"
                    >
                      No
                    </button>
                    <button
                      type="reset"
                      style={{ width: "120px" }}
                      onClick={() => this.handleDelete()}
                      className="btn btn-danger"
                    >
                      Yes
                    </button>
                  </div>
                </div>
              </div>
            </div>
            {/* </Form> */}
          </Spin>
        </Modal>
      </Fragment>
    );
  }

  //Approve Modal
  renderApproveButtonModal() {
    const { visible_approve } = this.state;
    return (
      <Fragment>
        <Modal
          centered
          visible={visible_approve}
          footer={null}
          closable={false}
          width={300}
          bodyStyle={{
            paddingTop: "0",
            paddingLeft: "15px",
            paddingRight: "15px",
            paddingBottom: "0",
          }}
        >
          <div className="p-3">
            <div className="row">
              <div className="col text-center justify-content-between">
                {window.location.hostname == "localhost" ? (
                  <img src={Api.absoluteUrl("/icon/approve_check.svg")} />
                ) : (
                  <img src={Api.absoluteUrl("/icon/approve_check.svg")} />
                )}
              </div>
            </div>

            <div className="row" style={{ margin: "20px 10px 20px 10px" }}>
              <div className="col text-center justify-content-between">
                <span
                  style={{
                    fontFamily: "MontserratM",
                    fontWeight: "bold",
                    color: "#0500A3",
                  }}
                >
                  {this.NotiModal()}
                </span>
              </div>
            </div>

            <div className="row">
              <div className="col text-center justify-content-between">
                <button
                  type="reset"
                  style={{ height: "30px", width: "100px" }}
                  onClick={() =>
                    this.setState({
                      visible_approve: false,
                      visible_delete: false,
                      visible: false,
                    })
                  }
                  className="btn btn-warning"
                >
                  Ok
                </button>
              </div>
            </div>
          </div>
        </Modal>
      </Fragment>
    );
  }

  //Reject modal
  renderRejectButtonModal() {
    const { visible_reject } = this.state;
    return (
      <Fragment>
        <Modal
          centered
          visible={visible_reject}
          footer={null}
          closable={false}
          width={300}
          bodyStyle={{
            paddingTop: "0",
            paddingLeft: "15px",
            paddingRight: "15px",
            paddingBottom: "0",
          }}
        >
          <div className="p-3">
            <div className="row">
              <div className="col text-center justify-content-between">
                {window.location.hostname == "localhost" ? (
                  <img src={Api.absoluteUrl("/icon/reject.svg")} />
                ) : (
                  <img src={Api.absoluteUrl("/icon/reject.svg")} />
                )}
              </div>
            </div>

            <div className="row" style={{ margin: "20px 10px 40px 10px" }}>
              <div className="col text-center justify-content-between">
                <span
                  style={{
                    fontFamily: "MontserratM",
                    fontWeight: "bold",
                    color: "#0500A3",
                  }}
                >
                  {this.state.error_log != null &&
                  this.state.error_log.includes(
                    "already have material_code:"
                  ) ? (
                    <>
                      <span style={{ color: "red" }}>
                        Add Permission Failed.
                      </span>
                      <br></br>
                      <span style={{ color: "red" }}>
                        {this.state.error_log}
                      </span>
                    </>
                  ) : (
                    <span style={{ color: "red" }}>
                      Submission Failed, Please Check Your Input
                    </span>
                  )}
                </span>
              </div>
            </div>

            <div className="row">
              <div className="col text-center justify-content-between">
                <button
                  type="reset"
                  style={{ height: "30px", width: "100px" }}
                  onClick={() =>
                    this.setState({ visible_reject: false, visible: false })
                  }
                  className="btn btn-warning"
                >
                  Ok
                </button>
              </div>
            </div>
          </div>
        </Modal>
      </Fragment>
    );
  }
  NotiModal() {
    const { processType } = this.state;
    if (processType == "add") {
      return "Successfully Added Job Type";
    } else if (processType == "edit") {
      return "Successfully Edited Job Type";
    } else if (processType == "delete") {
      return "Successfully Deleted Job Type";
    } else if (processType == "add sub") {
      return "Successfully Added Job Sub Type";
    } else if (processType == "edit sub") {
      return "Successfully Edited Job Sub Type";
    } else if (processType == "delete sub") {
      return "Successfully Deleted Job Sub Type";
    }
  }

  Search = (value) => {
    console.log(value);
    const {master_data} = this.state;
    if(value != undefined){
      var setdata = [];
      var obj = {};
          for (let i = 0; i < master_data.length; i++) {
              for (const [key, value] of Object.entries(master_data[i])) {
                  if (value == null || value == undefined) {
                  obj[`${key}`] = "-"
                  } else {
                  obj[`${key}`] = `${value}`
                  }
              }
              setdata.push(obj);
              obj = {};
          }        
      const filter_table = setdata.filter((o) =>
      Object.keys(o).some((k) =>
          String(o[k]).toLowerCase().includes(value.toLowerCase().trim())
      )
      );

      this.setState({
          data: filter_table
      })
    } else {
      this.setState({
        data: master_data
    })
    }
  }

  render() {
    const { title, data, columns } = this.state;
    // console.log(data);
    return (
      <div>
        {this.state.visible_approve ? this.renderApproveButtonModal() : null}
        {this.state.visible_reject ? this.renderRejectButtonModal() : null}
        {this.renderDelete()}
        {this.renderModal()}

        <span className="font-mont-r fs-12">Basic Data</span>
        <h3 className="font-mont-sb fs-18 c-blue">{title}</h3>

        <div className="d-flex justify-content-between m-3">
          <Input.Search
            placeholder="Search"
            onSearch={this.Search}
            allowClear            
            style={{ width: 200 }}
          />

          <button
            className="btn btn-warning"
            onClick={() => this.onModal("add", true)}
          >
            <img src={Api.absoluteUrl("/icon/plus.svg")} className="mr-2" />
            Add {title}
          </button>
        </div>

        <Table
          rowKey="ma_skill_id"
          columns={columns}
          dataSource={data}
          pagination={false}
        />
      </div>
    );
  }
}

export default JobSkill;
